import React from 'react';
import {BannerInfo, BannerWarning, Container} from "../../../index";
import {useProfileData} from "hooks";
import BannerBlock, {BannerBlockVariant} from "./BannerBlock";
import {IdentificationStatus, Role} from "../../../../api-client";

import styles from './AccountNotReadyWarningSection.module.scss';

const AccountNotReadyWarningSection = () => {
  const profileData = useProfileData();
  const {role} = profileData;
  const needIdentification = (): boolean => {
    return (!profileData.isVerified && !checkIdentificationStatus(IdentificationStatus.PENDING_REVIEW));
  };

  const checkIdentificationStatus = (status: IdentificationStatus) => {
    return status === profileData.identificationStatus;
  };

  const hasFirstDeposit = (): boolean => {
    return profileData.hasTransactions;
  };

  const needOnboardingBorrower = (): boolean => {
    return role === Role.BORROWER && profileData.isVerified && profileData.borrowerOnboardingComplete === false;
  };

  const showBannerSection = needIdentification() || !hasFirstDeposit() || needOnboardingBorrower();

  return (
    <>
      {showBannerSection ? <div className={styles.container}>
        <Container>
          {needIdentification() && (role === Role.LENDER) && <BannerWarning>
            <BannerBlock variant={BannerBlockVariant.IDENTIFICATION}/>
          </BannerWarning>}
          {needIdentification() && (role === Role.BORROWER) && <BannerWarning>
            <BannerBlock variant={BannerBlockVariant.IDENTIFICATION_BORROWER}/>
          </BannerWarning>}
          {needOnboardingBorrower() && <BannerWarning>
            <BannerBlock variant={BannerBlockVariant.ONBOARDING_BORROWER}/>
          </BannerWarning>}
          {!needIdentification() && !hasFirstDeposit() && checkIdentificationStatus(IdentificationStatus.PENDING_REVIEW) &&
          <BannerWarning>
            <BannerBlock variant={BannerBlockVariant.DEPOSIT}/>
          </BannerWarning>
          }
          {profileData.isVerified && !hasFirstDeposit() && (role === Role.LENDER) &&
          <BannerInfo>
            <BannerBlock variant={BannerBlockVariant.VERIFIED}/>
          </BannerInfo>
          }
        </Container>
      </div>:
        <div className={styles.header}></div>}
    </>
  );
};

export default AccountNotReadyWarningSection;